export default {
  meta: {
    title: '审核管理',
  }
};
